import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getLocalPageData } from './api';
import type { LocalPageDataErrorCode } from './types';

export const {
	Context: LocalPageDataContext,
	Provider: LocalPageDataContextProvider,
	useContext: useLocalPageData,
	useAsyncData: useLocalPageDataFromApi,
	prefetchAsyncData: prefetchLocalPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'LocalPageDataContext',
	dataProperty: 'pageData',
	getData: getLocalPageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler<LocalPageDataErrorCode>(),
});
